function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("style", {
  type: "text/css"
}, "\n\t.design1{fill-rule:evenodd;clip-rule:evenodd;fill:#F7ACC2;}\n");

var _ref3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  className: "design1",
  d: "M597,197.8c-34.2-14.5-81.1-14.1-130.3-13c-10.1,7-20.8,3.4-34.7,8.7c-34.9,13.2-79.2,45.3-99.9,73.8 c-98.5,135.6-3.2,253.2,47.8,360.4c83.9,0,167.9,0,251.8,0c6.5-4.5,39.9-74.4,47.8-86.8c14-22.2,34.3-46.2,43.4-73.8 C764.4,341.7,668.6,228.3,597,197.8z M670.8,458.3c-15.2,40.9-55.1,70.4-69.5,112.9c-63.7,0-127.4,0-191,0 c-9.4-6.2-11.1-28.9-17.4-39.1c-38.1-62-82-142-26.1-225.8c14.2-21.2,49.5-50.3,73.8-60.8c15.7-6.8,34.4-4.6,47.8-13 C606.7,231.9,718.1,330.9,670.8,458.3z M423.3,658.1c-16.2,19.3-27.4,51.9,0,69.5c6.5,2.8,1.9,5.4,8.7,0c57,0.6,141.8,9.1,178-13 c0.5-30-2.9-40.4-13-56.4C539.1,658.1,481.2,658.1,423.3,658.1z M453.7,801.4c59.7,14.3,88.8,9.9,130.3-17.4 c2.2-10.7,4-16,4.3-30.4c-53.5,0-107.1,0-160.7,0C431.3,780.2,442.3,784.4,453.7,801.4z"
})));

var SvgDesign = function SvgDesign(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_3",
    x: "0px",
    y: "0px",
    viewBox: "0 0 1000 1000",
    style: {
      enableBackground: "new 0 0 1000 1000"
    },
    xmlSpace: "preserve",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgDesign, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/Design.c3bd0175.svg";
export { ForwardRef as ReactComponent };